module.exports = __webpack_public_path__ + "static/media/ic_show_collect.40ea76b5.svg";